import { Link } from 'react-router-dom';

import { useLanguage } from '../context/LanguageContext';

function NotFoundPage() {
  const { language } = useLanguage();

  return (
    <section className="not-found">
      <span>404</span>
      <h1>{language === 'ru' ? 'Страница не найдена' : 'Page not found'}</h1>
      <Link className="button" to="/">{language === 'ru' ? 'На главную' : 'Return home'}</Link>
    </section>
  );
}

export default NotFoundPage;

